// extracted by mini-css-extract-plugin
module.exports = {"container":"index_container__vJU1D","icon":"index_icon__lqFbV","rightContainer":"index_rightContainer__1HOhm"};